<template>
  <RevCard class="p-16">
    <ItemWithIcon :icon="IconSim">
      {{ i18n(translations.bouyguesSIMCard) }}
    </ItemWithIcon>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconSim } from '@ds/icons/IconSim'

import ItemWithIcon from '../../../components/ItemWithIcon/ItemWithIcon.vue'

import translations from './BouyguesSIMCardItem.translations'

const i18n = useI18n()
</script>
